import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, orderBy } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { TarifaPPDescuentoEdit } from "./edit";
const EditModal = TarifaPPDescuentoEdit;
type Entity = models.TarifaPPDescuento;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Cant. guias", cell: x => ({ data: x.Cantidad }) },
        { title: "Descuento", cell: x => ({ data: x.Descuento, view: kea.formatPercent }) },
    ];
}

/**
* Listado de MatrizTarifaPeso
*/
class TarifaPPListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            const newList = orderBy([...oldList, newItem], x=> x.Cantidad );
            await this.props.onChange(newList);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            const newList = orderBy(oldList.map(x => x == item ? newItem : x) , x => x.Cantidad) ;
            await this.props.onChange(newList);
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.Cantidad + " guías");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Descuentos por cant. de guías</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda={true} />
                {this.modals.component}
            </div>
        );
    }
}
export const TarifaPPDescuentosList = kea.mapProps(componentToRx(TarifaPPListNoRx), x => ({...x, value: x.value || []}));



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapp/descuentos/index.tsx